import { Outlet } from 'react-router-dom'

export const OrderDispatchIndex = () => {
  return <Outlet />
}
